module.exports = __webpack_public_path__ + "static/media/weld_inspect_2.b547a38d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/weld_inspect_2.jpg
// module id = 1871
// module chunks = 0